var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideEyeWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visible-eye") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-login-screen-hide-password",
    transform: "translate(-318.000000, -287.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(23.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visible-eye",
    transform: "translate(295.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.266666667,8.73323457 C1.82716049,10.6887901 6.4691358,15.9036049 11.9604938,15.9036049 C17.4518519,15.9036049 22.0938272,10.6889877 23.654321,8.73323457 C23.9899259,8.29866667 23.9899259,7.68632099 23.654321,7.2717037 C22.0938272,5.31614815 17.4518519,0.101277371 11.9604938,0.101277371 C6.4691358,0.0815802469 1.82716049,5.29639506 0.266666667,7.25195062 C-0.0888888889,7.68651852 -0.0888888889,8.29866667 0.266666667,8.73323457 Z M11.9604938,3.24207407 C14.5876543,3.24207407 16.7012346,5.35565432 16.7012346,7.98281481 C16.7012346,10.6099753 14.5876543,12.7235556 11.9604938,12.7235556 C9.33333333,12.7235556 7.21975309,10.6099753 7.21975309,7.98281481 C7.21975309,5.35565432 9.33333333,3.24207407 11.9604938,3.24207407 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.9604938,
    cy: 7.98281481,
    r: 2.37037037
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideEyeWhite);
export default __webpack_public_path__ + "static/media/hide-eye-white.4139f4f7379ebb76f59684e72e874051.svg";
export { ForwardRef as ReactComponent };